import React, { useCallback, useContext, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { PaymentService } from '~/services/PaymentService';
import { FORBIDDEN_ROUTE, HOME_ROUTE } from '~/routing/routes';
import { LoadingContext } from '~/contexts/LoaderContext';
import { GeneralException } from '~/exceptions/generalException';

import './GetToken.scss';

type id = Record<string, string | undefined>;

const GetToken: React.FC = () => {
  const { token } = useParams<id>();
  const { push: redirect } = useHistory();
  const { t } = useTranslation();

  const { startLoading, stopLoading } = useContext(LoadingContext);

  const handleGetPaymentInfos = useCallback(async () => {
    startLoading();
    try {
      const res = await PaymentService.getPaymentDetails(token as string);
      if (res.code !== null) {
        redirect(HOME_ROUTE());
      } else {
        message.error(t('getToken:unableToCompleTransaction'), 2);
      }
      stopLoading();
    } catch (error: any) {
      stopLoading();
      const exception = error.response?.data as GeneralException;
      let finalException;

      if (exception !== null && exception !== undefined && exception.description !== null) {
        finalException = exception.description;
      }
      message.error(finalException || t('home:global:generalResponse'), 2);
      localStorage.removeItem('data');
      redirect(FORBIDDEN_ROUTE());
    }
  }, []);

  useEffect(() => {
    handleGetPaymentInfos();
  }, []);

  return (
    <div>
      <div></div>
    </div>
  );
};

export default GetToken;
